module.exports = __webpack_public_path__ + "img/ms.logo.072b3ba4.png";